export const InstancesColumns = {
  Name: 'name',
  Status: 'status',
  Role: 'role',
  AvailabilityZone: 'availabilityZone',
  Compute: 'compute',
  Endpoint: 'endpoint',
  Computeinfo: 'conputeInfo',
};
